// Simple Badge component
import React from 'react';

export function Badge({ children, variant = 'default', className = '' }) {
  const variants = {
    default: 'bg-amber-100 text-amber-800',
    secondary: 'bg-blue-100 text-blue-800', 
    outline: 'bg-gray-100 text-gray-800 border border-gray-300',
    destructive: 'bg-red-100 text-red-800'
  };

  return (
    <span className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
}

export default Badge;
